import React from 'react'
import { useTranslation } from 'next-i18next'

type PropsType = {
  text: string,
  isCentered?: boolean
}

const CustomHeaderText = ({ text, isCentered = false }: PropsType) => {
  const { t } = useTranslation()
  return (
    <div style={{ textAlign: isCentered ? 'center' : 'left' }}>
      {t(text)}
    </div>
  )
}

export default CustomHeaderText
